import { SvgIcon } from '@mui/material';
import './ccf-browse-acdfiles-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfBrowseACDFilesIconProps  {}

/**
 *
 * @param props - CcfBrowseACDFilesIcon
 * @example <CcfBrowseACDFilesIcon />
 * @returns
 */
export function CcfBrowseACDFilesIcon(props: CcfBrowseACDFilesIconProps) {
  return (
    <SvgIcon
      // width="20"
      // height="18"
      // viewBox="0 0 20 18"
      // fill="none"
      {...props}
    >
      <path
        d="M18 2H9.3L8.9 1.1C8.6 0.4 7.9 0 7.1 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H18C19.1 18 20 17.1 20 16V4C20 2.9 19.1 2 18 2ZM18 16H2V8H18V16ZM18 6H2V2H7.1L8.1 4H18V6Z"
        fill="#FF9400"
      />
    </SvgIcon>
  );
}

export default CcfBrowseACDFilesIcon;
